<template>
	<div>
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="Dashboard" :active="true"/>
		</b-breadcrumb>
		<b-container fluid>
			<b-row>
				<b-col>
					<CollapsibleCard title="Filters" :visible="false">
						<b-row class="p-3">
							<b-col cols="3">
								<b-form-group id="name-group" label="Group:" label-for="group" description="Select the server group to display">
									<b-input-group v-if="groupOptions !== null">
										<b-form-select v-model="group" placeholder="Select Group" :options="groupOptions" @input="loadServers()"></b-form-select>
									</b-input-group>
								</b-form-group>
							</b-col>
							<b-col cols="9">
								<span v-for="server in servers">
									<span :style="'cursor:pointer; color:' + server.color">
										<span @click="setVisible(server.id, !server.visible)" v-b-tooltip.hover :title="server.visible ? 'Hide' : 'Show'">
											<icon :name="server.visible ? 'eye' : 'eye-slash'"></icon> 
										</span>
										<span v-if="server.visible" @click="viewServerDashboard(server.id)">{{server.name}}</span>
										<span v-if="!server.visible" @click="viewServerDashboard(server.id)"><strike>{{server.name}}</strike>&nbsp;</span>
									</span>
									<!-- 
									<span :style="'cursor:pointer; color:' + server.color" v-if="server.visible == true" @click="setVisible(server.id, false)" v-b-tooltip.hover title="Hide">
										<icon name="eye"></icon> {{server.name}}
									</span>
									 -->
								</span>
							</b-col>
						</b-row>
					</CollapsibleCard>
				</b-col>
			</b-row>
			<b-row>
				<b-col lg="4" md="4" sm="6" xs="12" class="mt-2 mb-2">
					<b-card  ref="cpu">
						<b-row>
							<b-col cols="9"><h4 class="card-title">CPU</h4></b-col>
							<b-col cols="3" class="text-right" @click="fullscreenCpu()"><icon name="microchip" scale="1"></icon></b-col>
						</b-row>
						<div>
							<line-chart ref="cpuChart" v-if="cpuChartData != null" :chartData="cpuChartData" :options="relativeOptions" :height="250"></line-chart>
						</div>
					</b-card>
				</b-col>
				<b-col lg="4" md="4" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<b-row>
							<b-col cols="9"><h4 class="card-title">Memory</h4></b-col>
							<b-col cols="3" class="text-right"><icon name="memory" scale="1"></icon></b-col>
						</b-row>
						<div>
							<line-chart ref="memoryChart" v-if="memoryChartData != null" :chartData="memoryChartData" :options="relativeOptions" :height="250"></line-chart>
						</div>
					</b-card>
				</b-col>
				<b-col lg="4" md="4" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<b-row>
							<b-col cols="9"><h4 class="card-title">Swap</h4></b-col>
							<b-col cols="3" class="text-right"><icon name="memory" scale="1"></icon></b-col>
						</b-row>
						<div>
							<line-chart ref="swapChart" v-if="swapChartData != null" :chartData="swapChartData" :options="relativeOptions" :height="250"></line-chart>
						</div>
					</b-card>
				</b-col>
				<b-col lg="4" md="4" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<b-row>
							<b-col cols="9"><h4 class="card-title">Disk</h4></b-col>
							<b-col cols="3" class="text-right"><icon name="hdd" scale="1"></icon></b-col>
						</b-row>
						<div>
							<line-chart ref="diskChart" v-if="diskChartData != null" :chartData="diskChartData" :options="relativeOptions" :height="250"></line-chart>
						</div>
					</b-card>
				</b-col>
				<b-col lg="4" md="4" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<b-row>
							<b-col cols="9"><h4 class="card-title">Disk Read</h4></b-col>
							<b-col cols="3" class="text-right"><icon name="hdd" scale="1"></icon></b-col>
						</b-row>
						<div>
							<line-chart ref="diskReadBytesChart" v-if="diskReadBytesChartData != null" :chartData="diskReadBytesChartData" :options="absoluteOptions" :height="250"></line-chart>
						</div>
					</b-card>
				</b-col>
				<b-col lg="4" md="4" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<b-row>
							<b-col cols="9"><h4 class="card-title">Disk Write</h4></b-col>
							<b-col cols="3" class="text-right"><icon name="hdd" scale="1"></icon></b-col>
						</b-row>
						<div>
							<line-chart ref="diskWriteBytesChart" v-if="diskWriteBytesChartData != null" :chartData="diskWriteBytesChartData" :options="absoluteOptions" :height="250"></line-chart>
						</div>
					</b-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<b-row>
							<b-col cols="9"><h4 class="card-title">Network Received</h4></b-col>
							<b-col cols="3" class="text-right"><icon name="network-wired" scale="1"></icon></b-col>
						</b-row>
						<div>
							<line-chart ref="networkReceivedBytesChart" v-if="networkReceivedBytesChartData != null" :chartData="networkReceivedBytesChartData" :options="absoluteOptions" :height="250"></line-chart>
						</div>
					</b-card>
				</b-col>
				<b-col lg="6" md="6" sm="6" xs="12" class="mt-2 mb-2">
					<b-card>
						<b-row>
							<b-col cols="9"><h4 class="card-title">Network Sent</h4></b-col>
							<b-col cols="3" class="text-right"><icon name="network-wired" scale="1"></icon></b-col>
						</b-row>
						<div>
							<line-chart ref="networkSentBytesChart" v-if="networkSentBytesChartData != null" :chartData="networkSentBytesChartData" :options="absoluteOptions" :height="250"></line-chart>
						</div>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import {HTTP} from '../../services/HttpService'
import ToggleButton from '../../components/ToggleButton.vue'
import LineChart from '../../components/LineChart.vue'
import CollapsibleCard from '../../components/CollapsibleCard.vue'

export default {
  components: {
    ToggleButton,
    LineChart,
    CollapsibleCard
  },
  name: 'monitor',
  data: () => ({
    height: 250,
    group: '',
    groupOptions: null,
    servers: [],
    refreshInterval: null,
    cpuChartData: null,
    memoryChartData: null,
    swapChartData: null,
    diskChartData: null,
    diskReadBytesChartData: null,
    diskWriteBytesChartData: null,
    networkReceivedBytesChartData: null,
    networkSentBytesChartData: null,
    relativeOptions: {
      animation: {
        duration: 0
      },
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            max: 100
          }
        }]
      }
    },
    absoluteOptions: {
      animation: {
        duration: 0
      },
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            callback: function (value, index, values) {
              // var max = Math.max.apply(null, values)
              var max = value
              var divisor = 1
              var suffix = ''
              if (max > 1048576) {
                divisor = 1048576
                suffix = ' mb'
              } else if (max > 1024) {
                divisor = 1024
                suffix = ' kb'
              }
              return (value / divisor).toFixed(2) + suffix
            }
          },
          scaleLabel: {
            display: true,
            labelString: ''
          }
        }]
      }
    }
  }),
  methods: {
    loadGroups () {
      this.groupOptions = []
      this.groupOptions.push({
        value: '',
        text: 'All'
      })
      for (var i in this.servers) {
        var server = this.servers[i]
        var indexOf = this.groupOptions.map(function (element) {
          return element.text
        }).indexOf(server.group)
        if (indexOf < 0) {
          var option = {
            value: server.group,
            text: server.group
          }
          this.groupOptions.push(option)
        }
      }
    },
    loadServers () {
      HTTP.get('servers?group=' + this.group, {
        params: {
          page: 0,
          rowsPerPage: 1000
        }
      })
      .then(response => {
        this.servers = response.data.list
        if (this.groupOptions === null) {
          this.loadGroups()
        }
      })
    },
    toggleServer (server) {
      server.visible = !server.visible
    },
    updateData () {
      HTTP.get('metrics?group=' + this.group)
        .then(response => {
          var charts = response.data
          for (var i in charts.cpu.datasets) {
            charts.cpu.datasets[i].borderWidth = 1
            charts.cpu.datasets[i].pointRadius = 1
            charts.memory.datasets[i].borderWidth = 1
            charts.memory.datasets[i].pointRadius = 1
            charts.swap.datasets[i].borderWidth = 1
            charts.swap.datasets[i].pointRadius = 1
            charts.disk.datasets[i].borderWidth = 1
            charts.disk.datasets[i].pointRadius = 1
            charts.diskReadBytes.datasets[i].borderWidth = 1
            charts.diskReadBytes.datasets[i].pointRadius = 1
            charts.diskWriteBytes.datasets[i].borderWidth = 1
            charts.diskWriteBytes.datasets[i].pointRadius = 1
            charts.networkReceivedBytes.datasets[i].borderWidth = 1
            charts.networkReceivedBytes.datasets[i].pointRadius = 1
            charts.networkSentBytes.datasets[i].borderWidth = 1
            charts.networkSentBytes.datasets[i].pointRadius = 1
          }
          this.cpuChartData = charts.cpu
          this.memoryChartData = charts.memory
          this.swapChartData = charts.swap
          this.diskChartData = charts.disk
          this.diskReadBytesChartData = charts.diskReadBytes
          this.diskWriteBytesChartData = charts.diskWriteBytes
          this.networkReceivedBytesChartData = charts.networkReceivedBytes
          this.networkSentBytesChartData = charts.networkSentBytes
        })
    },
    setVisible (serverId, visible) {
      HTTP.post('servers/' + serverId + '/visible?visible=' + visible)
      .then(response => {
        this.loadServers()
      })
    },
    viewServerDashboard (serverId) {
      this.$router.push({
        name: 'ServerDashboardPage',
        params: {
          serverId: serverId
        }
      })
    },
    fullscreenCpu () {
      this.$refs.cpu.webkitRequestFullscreen()
    }
  },
  created () {
    this.loadServers()
    this.updateData()
    this.refreshInterval = setInterval(this.updateData, 1000)
  },
  destroyed () {
    clearInterval(this.refreshInterval)
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// ClassicDashboardPage.vue?709e6132